import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../../services/api';
import Constants from '../../../services/constants';
import { showLoader, hideLoader } from '../loaderSlice';
import { showToast } from '../toastSlice';

// Async thunk for changing password
export const changePassword = createAsyncThunk(
    'password/change',
    async ({ newPassword }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await api('put', Constants.END_POINT.user_settings_change_password, {
                newPassword: newPassword.toString()
            });
            
            if (response.success) {
                dispatch(showToast({ severity: 'success', summary: response.message || 'Password changed successfully' }));
                return response.data;
            } else {
                if (response.message?.includes('requires recent authentication')) {
                    // Redirect to login page with return URL
                    window.location.href = `/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
                    return rejectWithValue('Please log in again to change your password');
                }
                dispatch(showToast({ severity: 'error', summary: response.message }));
                return rejectWithValue(response.message);
            }
        } catch (error) {
            dispatch(showToast({ severity: 'error', summary: error.message }));
            return rejectWithValue(error.message);
        } finally {
            dispatch(hideLoader());
        }
    }
);

const passwordSlice = createSlice({
    name: 'password',
    initialState: {
        isLoading: false,
        error: null,
        success: false
    },
    reducers: {
        resetPasswordState: (state) => {
            state.isLoading = false;
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(changePassword.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(changePassword.fulfilled, (state) => {
                state.isLoading = false;
                state.error = null;
                state.success = true;
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.success = false;
            });
    }
});

export const { resetPasswordState } = passwordSlice.actions;
export default passwordSlice.reducer;
